// extracted by mini-css-extract-plugin
export default {"svg":"OpenFormButton_svg__Ea+8r","div":"OpenFormButton_div__lP56G"};